import { getRayon, getGorod } from "../../../../utilities";
export const fieldPassportOptions = {
  surname: {
    key: "surname",
    value: "Фамилия",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  name: {
    key: "name",
    value: "Имя",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  midname: {
    key: "midname",
    value: "Отчество",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  docType: {
    key: "docType",
    value: "Документ",
    type: "selectSearch",
    defaultValue: null,
    readOnly: false,
    isSearchable: false,
    required: true,
    options: [],
  },
  serialOfPassport: {
    key: "serialOfPassport",
    value: "Серия",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  numberOfPassport: {
    key: "numberOfPassport",
    value: "Номер",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  docDateIssue: {
    key: "docDateIssue",
    value: "Дата выдачи",
    type: "date",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  docDepartment: {
    key: "docDepartment",
    value: "Кем выдан",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  persNum: {
    key: "persNum",
    value: "Идентификационный номер",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
    maxlength: 14,
    customButton: true,
    buttonName: "Найти",
    customIcon: true,
    buttonDisabled: false,
  },
};

export const fieldAddressOptions = {
  stranId: {
    key: "stranId",
    value: "Страна",
    type: "text",
    defaultValue: "Республика Беларусь",
    readOnly: true,
  },
  oblId: {
    key: "oblId",
    value: "Область или г. Минск",
    type: "selectSearch",
    defaultValue: null,
    disabled: false,
    readOnly: false,
    isSearchable: true,
    required: true,
    options: [],
  },
  rayonId: {
    key: "rayonId",
    value: "Район",
    type: "selectSearch",
    defaultValue: null,
    disabled: true,
    readOnly: false,
    isSearchable: true,
    required: false,
    options: [],
  },
  gorodId: {
    key: "gorodId",
    value: "Населенный пункт",
    type: "selectSearch",
    defaultValue: null,
    disabled: true,
    readOnly: false,
    isSearchable: true,
    required: false,
    options: [],
  },
  ulica: {
    key: "ulica",
    value: "Улица",
    type: "text",
    defaultValue: null,
    readOnly: false,
  },
  dom: {
    key: "dom",
    value: "Дом",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
  korpus: {
    key: "korpus",
    value: "Корпус",
    type: "text",
    defaultValue: null,
    readOnly: false,
  },
  kv: {
    key: "kv",
    value: "Квартира",
    type: "text",
    defaultValue: null,
    readOnly: false,
  },
  phone: {
    key: "phone",
    value: "Телефон",
    type: "text",
    defaultValue: null,
    readOnly: false,
    required: true,
  },
};

export async function setOptions(prop, key) {
  if (prop) {
    switch (key) {
      case "firstInit": {
        fieldAddressOptions.oblId.options = prop.oblast;
        fieldPassportOptions.docType.options = prop.docType;
        fieldAddressOptions.rayonId.options = [];
        fieldAddressOptions.rayonId.disabled = true;
        fieldAddressOptions.gorodId.options = [];
        fieldAddressOptions.gorodId.disabled = true;
        return fieldAddressOptions;
      }
      case "oblId": {
        if (Number(prop) === 5) {
          fieldAddressOptions.rayonId.options = [];
          fieldAddressOptions.rayonId.disabled = true;
          fieldAddressOptions.rayonId.required = false;
          fieldAddressOptions.gorodId.options = [];
          fieldAddressOptions.gorodId.disabled = true;
          fieldAddressOptions.gorodId.required = false;
        } else {
          fieldAddressOptions.rayonId.options = await getRayon(prop);
          fieldAddressOptions.rayonId.disabled = fieldAddressOptions.rayonId.options.length ? false : true;
          fieldAddressOptions.rayonId.required = true;
          fieldAddressOptions.gorodId.options = [];
          fieldAddressOptions.gorodId.disabled = true;
          fieldAddressOptions.gorodId.required = true;
        }
        return fieldAddressOptions;
      }
      case "rayonId": {
        fieldAddressOptions.gorodId.options = await getGorod(prop);
        fieldAddressOptions.gorodId.disabled = fieldAddressOptions.gorodId.options.length ? false : true;
        return fieldAddressOptions;
      }
      default:
        return fieldAddressOptions;
    }
  }
}
export function getOptions() {
  return {
    passport: fieldPassportOptions,
    address: fieldAddressOptions,
  };
}
